import type { DetectedMeeting, GoogleMeetMeeting, RecallDetectedMeeting } from '@highlight/common'
import type { CapturePlan } from '@shared/store/impl/audioSettings'

export interface AudioCaptureNeeds {
  microphone: boolean
  systemAudio: boolean
  screenRecording: boolean
}

export type ScreenCaptureStatus = 'authorized' | 'denied' | 'restartRequired' | 'error'

export type ScreenCaptureRequestOutcome = 'granted' | 'denied' | 'openSettings' | 'restartRequired' | 'error'

export type SystemAudioCaptureStatus = 'authorized' | 'denied' | 'notDetermined' | 'unavailable' | 'error'

export type MicrophoneRequestOutcome = 'granted' | 'pending' | 'error'

export type SystemAudioRequestOutcome = 'granted' | 'pending' | 'openSettings' | 'unavailable' | 'error'

/** Authoritative OS permission statuses mirrored from main under the `permissions` GlobalState key. */
export interface PermissionsState {
  accessibilityAccess?: boolean
  microphoneAccess?: boolean
  screenCaptureStatus?: ScreenCaptureStatus
  systemAudioCaptureStatus?: SystemAudioCaptureStatus
}

/**
 * GlobalState key for the outcome of the last Screen Recording request. This
 * is UX session state that drives the Settings action wording, so it lives
 * outside the OS-status mirror above.
 */
export const SCREEN_CAPTURE_REQUEST_STATE_KEY = 'permissions.screenCaptureRequest'

export interface AudioPermissionRequiredPayload {
  meeting?: DetectedMeeting | GoogleMeetMeeting | RecallDetectedMeeting
  /** The capture plan main committed to for this recording; surfaces derive needs from it. */
  plan: CapturePlan
}
